import React from 'react'

const Explance = () => {
  return (




    <section className='justify-center w-full aglign-center bg-white xl:max-w-full lg:max-w-xl '>
   


<div className='absolute flex justify-center w-full z-10  xl:max-w-full lg:max-w-xl xl:max-w-full lg:max-w-xl'>

<div class="flex flex-col justify-center anglign-center items-center py-40 px-20 mx-auto max-w-screen-xl lg:grid lg:grid-cols-2 lg:py-16 lg:px-6 ">
        <div class="font-light text-slate-950 sm:text-lg dark:text-gray-400">
            <h2 class="mb-4 text-4xl tracking-tight font-extrabold text-gray-900">Business Solutions</h2>
            <p class="mb-4 text-black">Our team of experienced professionals works closely with you to ensure that your vision becomes a reality. Whether you’re looking to build a powerful online presence, optimize your website for better performance, or implement marketing strategies that generate leads, [Your Business Name] is your trusted partner.</p>
            <p className='mb-4'>We are strategists, designers and developers. Innovators and problem solvers. Small enough to be simple and quick.</p>

            <button type="button" class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">Default</button>
            
  </div>

  <img src="/Img/pngegg (2).png" className='justify-self-end visible xl:max-w-full lg:max-w-xl xl:visible lg:visible md:invisible sm:invisible invisible'></img>
  
    
 </div>
 </div>

 <div className='flex flex-row-reverse '>
 <img src="/Img/Hero.png" className='justify-self-end bg-image bg-cover '></img>
  
 </div>
   
    </section>
  )
}

export default Explance
